module.exports = __webpack_public_path__ + "1_0_64/img/200 Statue of Liberty.e595ad70.jpg";